import { Component, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-href-grid',
  templateUrl: './href-grid-component.html',
  styleUrl: './href-grid-component.scss',
  standalone: false,
})
export class HRefGridComponent implements ICellRendererAngularComp {
  value = signal('');
  url: string;
  data: any;
  route: string;
  idProperty: string;

  constructor(private readonly router: Router) {}

  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.data = params.data;
    this.route = params['route'];
    this.idProperty = params['idProperty'];
    this.url = this.route + this.data[this.idProperty];
    this.value.set(params.value);
    return true;
  }

  protected onNavigate(event: MouseEvent): void {
    //laisser le navigateur ouvrir un nouvel onglet / une nouvelle fenêtre
    if (
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey ||
      event.button !== 0
    )
      return;

    event.preventDefault();
    this.router.navigate([this.url]);
  }
}
